// src/analytics/ga.js
export function setupGA(id) {
  const GA_ID = id ?? import.meta.env.VITE_GA_ID;
  const GA_DEBUG = import.meta.env.VITE_GA_DEBUG === 'true';

  if ((!import.meta.env.PROD && !GA_DEBUG) || !GA_ID || window.gtag) {
    return;
  }

  const s = document.createElement('script');
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(GA_ID)}`;
  document.head.appendChild(s);

  window.dataLayer = window.dataLayer || [];
  function gtag() {
    window.dataLayer.push(arguments);
  }
  window.gtag = gtag;

  gtag('js', new Date());
  gtag('config', GA_ID, {
    anonymize_ip: true,
    debug_mode: GA_DEBUG,
  });

  if (GA_DEBUG) {
    console.log('[GA] setupGA inicializado', { GA_ID, GA_DEBUG });
  }
}